module.exports = __webpack_public_path__ + "static/media/trintamais.f2a08909.png";